import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Chip,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';

const ProductList = ({ products, selectedId, onSelect }) => {
  const productIds = Object.keys(products);

  return (
    <Card sx={{ width: 320, maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1, overflow: 'auto', p: 2 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Products ({productIds.length})
        </Typography>

        <List sx={{ p: 0 }}>
          {productIds.map((id) => {
            const product = products[id];
            const isSelected = id === selectedId;
            const hasModel = product.modelUrl && !product.modelUrl.includes('placeholder');

            return (
              <ListItem key={id} disablePadding sx={{ mb: 1 }}>
                <ListItemButton
                  onClick={() => onSelect(id)}
                  selected={isSelected}
                  sx={{
                    border: 2,
                    borderColor: isSelected ? 'primary.main' : 'grey.300',
                    borderRadius: 1.5,
                    bgcolor: isSelected ? 'action.selected' : 'background.paper',
                    '&:hover': {
                      bgcolor: isSelected ? 'action.selected' : 'action.hover',
                    },
                    transition: 'all 0.2s ease',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    p: 1.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{ mb: 0.5 }}
                  >
                    Product {id}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mb: 0.5,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      width: '100%',
                    }}
                  >
                    {product.name}
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      mb: 0.5,
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      ${product.basePrice}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {product.tiers?.length || 0} tiers
                    </Typography>
                  </Box>

                  {product.modelUrl && (
                    <Chip
                      size="small"
                      icon={hasModel ? <CheckCircleIcon /> : <WarningIcon />}
                      label={hasModel ? 'Has model' : 'Placeholder'}
                      color={hasModel ? 'success' : 'warning'}
                      sx={{ height: 20, fontSize: '0.688rem' }}
                    />
                  )}
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
};

export default ProductList;
